export const defaultLocale = "de";
export const localeOptions = [
  { id: "en", name: "English", direction: "ltr" },
  { id: "de", name: "Deutsch", direction: "ltr" }
];
export const isCWADisabled = process.env.VUE_APP_IS_CWA_DISABLED === "true";
export const isCWADccDisabled = process.env.VUE_APP_IS_CWA_DCC_DISABLED === "true";
